module.exports = __webpack_public_path__ + "static/img/e-banner-m2.f8b9ae17.jpg";